
const moduleData = {
  id: "module-epilogue",
  title: "Epilogue",
  subtitle: "Dissolving into eternal SAI by practising HIS SRUTI and living HIS VAIBHAVAM",
   cardImage: "/enBanner/epilogue_banner.jpg",
  pdfPath: "/en/Modules/epilogue.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/epilogue.mp3",
    duration: "0:00"
  },
  video: {
    id: "s-y_2_Q-2_Q"
  },
  hero: {
    title: "Epilogue",
    subtitle: "Dissolving into eternal SAI by practising HIS SRUTI and living HIS VAIBHAVAM",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/epilogue_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Dissolving into eternal SAI by practising HIS SRUTI and living HIS VAIBHAVAM?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
